<form [formGroup]="form" (ngSubmit)="submit()">
  <div class="modal-header">
    <h5 class="modal-title">{{ isUpdate ? 'Edit Website' : 'Add Website' }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancelled.emit()"></button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <select-field label="Client" [options]="clientOptions" [selectFormControl]="control('clientId')" />
      @if (isLoadingClients) {
        <small class="text-muted">Loading clients...</small>
      }
    </div>
    <div class="mb-3">
      <input-field type="text" label="URL" placeholder="www.example.com" [inputFormControl]="control('url')" />
    </div>
    <div class="mb-1">
      <switch-field message="Scan enabled" [isChecked]="form.controls.scanEnabled.value" (valueChange)="onScanEnabledChange($event)" />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelled.emit()">Cancel</button>
    <button type="submit" class="btn btn-success" [disabled]="isSaving">Save</button>
  </div>
</form>
